import React from 'react';
import {
  PrinterIcon,
  DocumentArrowDownIcon,
  TableCellsIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';
import { Button } from '../ui';

interface CasePrintToolbarProps {
  viewMode: 'panel' | 'table';
  onViewModeChange: (mode: 'panel' | 'table') => void;
  onPrint: () => void;
  onPdfExport: () => void;
  onCsvExport: () => void;
  isExporting?: boolean;
  className?: string;
}

export const CasePrintToolbar: React.FC<CasePrintToolbarProps> = ({
  viewMode,
  onViewModeChange,
  onPrint,
  onPdfExport,
  onCsvExport,
  isExporting = false,
  className = '',
}) => {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* 表示モード切り替えボタン */}
      <div className='flex items-center bg-gray-100 dark:bg-gray-700 rounded-lg p-1 no-print'>
        <Button
          onClick={() => onViewModeChange('panel')}
          variant={viewMode === 'panel' ? 'primary' : 'ghost'}
          size='sm'
          className='px-3 py-2'
          title='パネル表示'
          aria-label='パネル表示に切り替え'
        >
          <Squares2X2Icon className='h-4 w-4' />
        </Button>
        <Button
          onClick={() => onViewModeChange('table')}
          variant={viewMode === 'table' ? 'primary' : 'ghost'}
          size='sm'
          className='px-3 py-2'
          title='表表示'
          aria-label='表表示に切り替え'
        >
          <TableCellsIcon className='h-4 w-4' />
        </Button>
      </div>

      {/* 区切り線 */}
      <div className='h-6 w-px bg-gray-300 dark:bg-gray-600 no-print' />

      {/* 印刷・PDF出力ボタン */}
      <div className='flex items-center space-x-1 no-print'>
        <Button
          onClick={onPrint}
          variant='secondary'
          size='sm'
          className='px-3 py-2'
          title='印刷'
          aria-label='案件一覧を印刷'
        >
          <PrinterIcon className='h-4 w-4 mr-1' />
          <span className='hidden sm:inline'>印刷</span>
        </Button>

        <Button
          onClick={onPdfExport}
          variant='primary'
          size='sm'
          className='px-3 py-2'
          disabled={isExporting}
          title='PDF出力'
          aria-label='案件一覧をPDF出力'
        >
          <DocumentArrowDownIcon className='h-4 w-4 mr-1' />
          <span className='hidden sm:inline'>{isExporting ? 'PDF生成中...' : 'PDF出力'}</span>
          <span className='sm:hidden'>{isExporting ? '生成中...' : 'PDF'}</span>
        </Button>

        <Button
          onClick={onCsvExport}
          variant='secondary'
          size='sm'
          className='px-3 py-2'
          title='CSV出力'
          aria-label='案件一覧をCSV出力'
        >
          <TableCellsIcon className='h-4 w-4 mr-1' />
          <span className='hidden sm:inline'>CSV出力</span>
          <span className='sm:hidden'>CSV</span>
        </Button>
      </div>
    </div>
  );
};
